export const ACCOUNTTYPES = {
  INDIVIDUAL: 'individual',
  SMSF: 'smsf',
  TRUST: 'trust',
  MINOR: 'minor',
  CORPORATION: 'corporation',
  ADVISOR: 'advisor',
  JOINT: 'joint',
};
